import React from 'react'

import { Link, navigate } from 'gatsby'
import $ from 'jquery'

//Helpers
import {
  getLocation,
  getName,
  getFakeAddress,
  getStatus,
  is_Sold,
} from '@helpers/helper.developments'
import { ElementHTML, getCover, getQuality } from '@helpers/helper.rendering'
import { getEnvironment, getPrices, getSurface, makeLink } from '@helpers/helper.properties'
import { Development, Property, RealEstateDataPageComponentData } from 'types'

interface Props {
  development: Development
  inMap: boolean
  unities: Property[]
}

const Development_Card_2 = (props: Props & RealEstateDataPageComponentData) => {
  const { development, global_data, darkMode } = props
  const { divisionPath } = global_data
  const hidden = global_data.content.cardsDevelopments.data.hidden
  const { titleElement, titleColor, subtitleElement, subtitleColor } =
    global_data.content.cardsDevelopments.data
  const inMap = props?.inMap
  const unities = props?.unities

  const makeUrlUnities = (unities: Property[]) => {
    let url = ''
    unities.forEach((unity, index) => {
      url += `${unity.id}`
      if (index !== unities.length - 1) {
        url += `-`
      }
    })
    return url
  }

  const toggleModal = (boolean: boolean) => {
    document.body.classList.remove('modal-open')
    $('#exampleModal').hide()
    $('.modal-backdrop').hide()
    document.body.classList.remove('modal-open')
    document.body.style.overflow = 'auto'
  }

  return inMap ? (
    <div className={'card dev dev-card b ' + (inMap ? 'map-card' : '')}>
      <div className={'card-image grid_map_image'}>
        <a target="_blank">
          <img
            src={getQuality(getCover(development.photos))}
            className="notScale"
            alt={'Imagen del emprendimiento Tokko'}
          />
        </a>
        {inMap ? (
          <div
            data-bs-dismiss="modal"
            className="close-card"
            onClick={() => toggleModal(false)}
          >
            <i className="icon-close-light"></i>
          </div>
        ) : null}
      </div>
      <div className="card-body">
        <div className="content-extra row d-flex justify-content-between align-items-start">
          <div className="col-12 mt-2 mb-4 extra-data">
            <span className="d-block">{'EMPRENDIMIENTO'}</span>
          </div>
        </div>
        <div className="content-extra">
          <h3 className="d-flex flex-column mb-0">
            {hidden ? getFakeAddress(development) : getName(development)}
            {/* <div className="mt-2">
              <a target={'__blank'}>{getFakeAddress(development)}</a>
            </div> */}
          </h3>
          <span className="d-block mt-0 mb-4">{getLocation(development)}</span>

          <div className="unity mb-3">
            {unities.length < 7
              ? unities.map((unity, index) => (
                  <div
                    className="item-unity mb-2 d-flex align-items-center"
                    key={index}
                  >
                    <div className="d-flex flex-row w-100 text-wrapper">
                      <span className="me-3">
                        {getEnvironment(unity)} ambientes · {getSurface(unity) || '000.00 M2'}
                      </span>
                      {getPrices(unity).map((prop, index) => (
                        <span key={index}>
                          ({prop?.currency}
                          {typeof prop?.price === 'number'
                            ? Intl.NumberFormat('de-DE').format(prop?.price)
                            : prop?.price}
                          )
                        </span>
                      ))}
                    </div>
                    <a
                      className="w-auto read-more d-flex justify-content-end align-items-center"
                      target={'_blank'}
                      href={makeLink(unity, divisionPath)}
                    >
                      Ver <span>+</span>
                    </a>
                  </div>
                ))
              : ''}
          </div>
        </div>
        <a
          target="_blank"
          href={
            (divisionPath ?? '') +
            '/emprendimiento/' +
            development?.name?.replaceAll(' ', '-')?.replaceAll('/', '-')?.toLowerCase() +
            '/' +
            development?.id +
            (props.unities ? '?unidades=' + makeUrlUnities(props.unities) : '')
          }
          className="btn btn-secondary text-white w-100 mt-auto"
        >
          <span className="d-block d-lg-inline">VER MÁS</span>
        </a>
      </div>
    </div>
  ) : (
    <div
      className={`card dev dev-card b ${props.inMap ? 'map-card' : ''} ${
        darkMode ? 'dark-mode' : ''
      }`}
      onClick={() =>
        darkMode &&
        navigate(
          (divisionPath ?? '') +
            '/emprendimiento/' +
            development?.name?.replaceAll(' ', '-')?.replaceAll('/', '-')?.toLowerCase() +
            '/' +
            development?.id +
            (props.unities ? '?unidades=' + makeUrlUnities(props.unities) : ''),
        )
      }
    >
      {is_Sold(development) && <div className="development-end-tag">100% VENDIDO</div>}
      <div className="card-image">
        <img
          className="card-img"
          src={development && getQuality(getCover(development.photos))}
          alt={'Imagen del emprendimiento Tokko'}
        />
      </div>
      <div className="card-img-overlay d-flex justify-content-center align-items-center text-center text-white">
        <div className="content text-center">
          <div className="badge badge-development">{development && getStatus(development)}</div>
          {darkMode ? (
            <>
              <ElementHTML
                elementType={titleElement || 'h3'}
                className="title"
                style={{ color: titleColor || '#fff' }}
                children={development && (hidden ? development.fake_address : getName(development))}
              />
              {!hidden && (
                <ElementHTML
                  elementType={subtitleElement || 'p'}
                  className="subtitle"
                  style={{ color: subtitleColor || '#fff' }}
                  children={development && getLocation(development, true)[0]}
                />
              )}
            </>
          ) : (
            <h4 className="card-title mt-lg-5 mt-4 mb-lg-4 mb-3">
              {development && (hidden ? development.fake_address : getName(development))}
              <br />
              {development && getFakeAddress(development)}
              <br />
              {development && getLocation(development, true)[0]}
              <br />
              {development && getLocation(development, true)[1]}
            </h4>
          )}
          {props.inMap ? (
            <a
              target={'__blank'}
              href={
                (divisionPath ?? '') +
                '/emprendimiento/' +
                development?.name?.replaceAll(' ', '-')?.toLowerCase() +
                '/' +
                development?.id +
                (props.unities ? '?unidades=' + makeUrlUnities(props.unities) : '')
              }
              className="btn btn-outline mt-auto"
            >
              <span className="d-none d-lg-inline">VER MÁS</span>
              <span className="d-lg-none">+</span>
            </a>
          ) : (
            !darkMode && (
              <Link
                to={
                  (divisionPath ?? '') +
                  '/emprendimiento/' +
                  development?.name?.replaceAll(' ', '-')?.toLowerCase() +
                  '/' +
                  development?.id +
                  (props.unities ? '?unidades=' + makeUrlUnities(props.unities) : '')
                }
                className="btn btn-outline mt-auto"
              >
                <span className="d-block d-lg-inline">VER MÁS</span>
              </Link>
            )
          )}
        </div>
      </div>
    </div>
  )
}

export default Development_Card_2
